import { FinalImpactScoreType } from '@upright/common/model/output/scores/types';
import { useCarouselContext } from '../context';

export function AggregateResultArea(props: { scoreUnit?: FinalImpactScoreType }) {
  const context = useCarouselContext();
  const lens = context.lens;
  const Component = lens.AggregateResultArea;
  return Component ? <Component scoreUnit={props.scoreUnit} /> : <></>;
}
